
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    best: {
      type: Boolean,
      default: false,
    },
    percentage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedName(): string {
      return this.name ? this.name.replaceAll(" ", "_") : "--";
    },
  },
});
